import moji from 'moji'
import favs from './modules/favs'
import editControl from './modules/edit-control'
import history from './modules/history'
import play from './modules/play'
export default {
    debug: true,
    favs: favs,
    editControl: editControl,
    history: history,
    play: play,
    state: {
        currentPage: {
            data: 1,
            required: false
        },
        perPage: {
            data: process.env.NODE_ENV === 'production' ? 200 : 10,
            required: false
        },
        selectMode: {
            data: false,
            required: true
        },
        pageState: {
            data: false,
            required: true
        },
        audioSources: {
            data: [],
            required: true
        },
        allItems: {
            data: [],
            required: true
        },
        items: {
            data: [],
            required: true
        },
        bannerItem: {
            data: {},
            required: true
        },
        selectedItems: {
            data: [],
            required: true
        },
        videoInfos: {
            data: [],
            required: true
        },
        favState: {
            data: false,
            required: true,
        },
        pageType: {
            data: 'normal',
            required: true
        }
    },
    getNowPageItems: function () {
        return this._fetchCurrentPageItems(this.state.items.data,this.state.currentPage.data,this.state.perPage.data)
    },
    _fetchCurrentPageItems: function (items, currentPage, perPage) {
        const start = (currentPage - 1) * perPage
        const end = Math.min(start + perPage, items.length)
        return items.slice(start, end)
    },
    setSelectMode: function (selectMode) {
        this.state.selectMode.data = selectMode
    },
    getSelectMode: function () {
        return this.state.selectMode.data
    },
    setPageState: function (pageState) {
        this.state.pageState.data = pageState
    },
    getPageState: function () {
        return this.state.pageState.data
    },
    getVideoInfos: function () {
        return this.state.videoInfos.data
    },
    loadVideoInfos: function (loadedVideoInfos) {
        this.state.videoInfos.data = loadedVideoInfos
    },
    loadAudioSources: function (loadedJsonData) {
        const setSearchWord = function (items) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                item.searchWord = moji(item.buttonDesc)
                    .convert('HK', 'ZK')
                    .convert('KK', 'HG')
                    .toString()
            }
        }.bind(this)

        const setKeyIdx = function (items) {
            items.forEach((item) => {
                item.keyIdx = item.serialId
            })
        }.bind(this)

        const setNaturalOrder = function (items) {
            items.forEach((item, index) => {
                item.naturalOrder = items.length - index
            })
        }

        const items = loadedJsonData.items
        setSearchWord(items)
        setKeyIdx(items)
        setNaturalOrder(items)

        this.state.items.data = items
            .reverse()
            .filter((item) => item.visible !== false)
        this.state.bannerItem.data = items.find(
            item => item.serialId === '1'
        )
        this.state.allItems.data = items
    },
    setFavToAudioSources: function (buttonFavs) {
        for (const item of this.state.allItems.data) {
            if (!(item.serialId in buttonFavs)) {
                item.fav = false
            } else {
                item.fav = buttonFavs[item.serialId]
            }
        }
    },
    getAllItems: function () {
        return this.state.allItems.data
    },
    setSelctedItems: function (query) {
        const queryButton = query.b
        if (!queryButton) {
            this.state.selectedItems.data = []
            return
        }

        const itemsmap = {}
        for (const item of this.state.allItems.data) {
            itemsmap[item.serialId] = item
        }

        const selectedItems = []
        const queryButtons = queryButton.split('-')
        for (const button of queryButtons) {
            if (button in itemsmap) {
                const selectedItem = { ...itemsmap[button] }
                selectedItem.keyIdx = selectedItem.length
                selectedItems.push(selectedItem)
            }
        }

        this.state.selectedItems.data = selectedItems
    },
    getItems: function () {
        return this.state.items.data
    },
    getbannerItem: function () {
        return this.state.bannerItem.data
    },
    getSelectedItems: function () {
        return this.state.selectedItems.data
    },
    setFavMode: function (state) {
        this.state.favState.data = state
    },
    getFavMode: function () {
        return this.state.favState.data
    },
    setPageType: function(type) {
        this.state.pageType.data = type
    },
    getPageType: function() {
        return this.state.pageType.data
    },
    getMiniButtonType: function() {
        const pageType = this.state.pageType.data
        switch (pageType) {
            case 'light':
                return 'button'
            case 'normal':
                return 'mini'
            default:
                return 'mini'
        }
    }

}
